module.exports = __webpack_public_path__ + "img/2.24976dc7.jpg";